var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_3977)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5389 32.173C53.0111 32.173 60.8892 26.1309 66.4171 26.1309C71.945 26.1309 83.5549 29.3619 83.5549 55.2184C83.5549 81.075 67.9363 84.8692 61.8561 84.8692C33.3838 84.8709 21.2217 32.173 41.5389 32.173Z",
    fill: "url(#paint0_linear_390_3977)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6293 35.0691C86.0402 35.0691 84.7471 33.7542 84.7471 32.1385C84.7471 30.5228 86.0402 29.208 87.6293 29.208C89.2184 29.208 90.5116 30.5228 90.5116 32.1385C90.5116 33.7542 89.2184 35.0691 87.6293 35.0691ZM87.6293 31.1617C87.1009 31.1617 86.6686 31.5993 86.6686 32.1385C86.6686 32.6778 87.1009 33.1154 87.6293 33.1154C88.1577 33.1154 88.5901 32.6778 88.5901 32.1385C88.5901 31.5993 88.1577 31.1617 87.6293 31.1617Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8926 74.6289H24.5147V72.94H27.8926V74.6289Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6045 74.6289H34.2266V72.94H37.6045V74.6289Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6943 80.5391H30.0054V77.1612H31.6943V80.5391Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6934 70.8281H30.0044V67.4503H31.6934V70.8281Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5553 57.014H43.5348C42.7102 57.014 42.041 56.3447 42.041 55.5202V46.5573C42.041 45.7327 42.7102 45.0635 43.5348 45.0635H72.4152C73.2398 45.0635 73.909 45.7327 73.909 46.5573V51.0387H70.9214V48.0511H45.0286V54.0263H67.5553V57.014Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1436 59.9814H63.0967V62.9691H42.1436V59.9814Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1436 65.9561H57.1613V68.9437H42.1436V65.9561Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0272 78.923C58.6348 78.923 58.2524 78.7677 57.9716 78.4848C57.627 78.1403 57.4717 77.6483 57.5573 77.1703L58.6129 71.1851C58.6667 70.8823 58.8121 70.6035 59.0272 70.3884L73.816 55.5996C74.4453 54.9702 75.1126 54.5779 75.7997 54.4345C76.7478 54.2353 77.67 54.5241 78.393 55.2491L80.8568 57.7129C82.2152 59.0733 82.2152 61.2821 80.8568 62.6425L66.07 77.4312C65.8529 77.6463 65.5741 77.7937 65.2733 77.8455L59.2881 78.9011C59.2005 78.9151 59.1149 78.923 59.0272 78.923ZM61.4731 72.167L60.8696 75.5869L64.2894 74.9833L78.7435 60.5272C78.9367 60.332 78.9367 60.0173 78.7435 59.8221L76.2977 57.3763C76.2778 57.4141 76.1284 57.5077 75.9272 57.7089L61.4731 72.167Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.656 74.9396H39.5545C36.533 74.9396 34.0771 72.4837 34.0771 69.4623V36.5984C34.0771 33.5769 36.533 31.1211 39.5545 31.1211H76.4018C79.4233 31.1211 81.8791 33.5769 81.8791 36.5984V51.1183H78.8915V36.5984C78.8915 35.2261 77.7741 34.1087 76.4018 34.1087H39.5545C38.1821 34.1087 37.0648 35.2261 37.0648 36.5984V69.4623C37.0648 70.8346 38.1821 71.952 39.5545 71.952H53.656V74.9396Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5713 38.0918H80.3856V41.0794H35.5713V38.0918Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_3977",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_3977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_3977",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_3977",
    x1: 57.4991,
    y1: 26.1309,
    x2: 57.4991,
    y2: 84.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1FE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk9);
export default __webpack_public_path__ + "static/media/uwalk9.1c947c4ca7e8bf4db35978d205351695.svg";
export { ForwardRef as ReactComponent };